import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import parse from "html-react-parser";
import dayjs from "dayjs";
import { Img } from "../Images";
import { Heading } from "../../components/Headings/Heading";
import * as styles from "./Testimonial.module.scss";

const Testimonial = ({
	className,
	classNames,
	displayTitle,
	image,
	quote,
	source,
	date,
	branding,
}) => {
	let parsedDate = null;

	if (date) {
		parsedDate = dayjs(date).format("MMMM YYYY");
	}

	return (
		<div className={cx(className)}>
			{displayTitle && branding !== "default" && (
				<Heading as="h2" uppercase className={classNames?.heading}>
					{displayTitle}
				</Heading>
			)}

			{quote && (
				<div className={cx(styles.testimonialQuote, image && classNames?.quoteContainer)}>
					{image && (
						<Img
							fluid={image.fluid}
							src={image.src}
							alt={image.alt}
							wrapperClassName={cx(classNames?.image)}
						/>
					)}
					<div className={cx(styles.testimonialTextContent, classNames?.textContent)}>
						{displayTitle && branding === "default" && (
							<Heading as="h3" className={classNames?.heading}>
								{displayTitle}
							</Heading>
						)}
						{parse(quote)}
						{source ? (
							<div className={cx(styles.testimonialSource, classNames?.source)}>
								{source}
								{parsedDate && ` - ${parsedDate}`}
							</div>
						) : (
							parsedDate && (
								<div className={cx(styles.testimonialSource, classNames?.source)}>{parsedDate}</div>
							)
						)}
					</div>
				</div>
			)}
		</div>
	);
};

Testimonial.propTypes = {
	className: PropTypes.string,
	classNames: PropTypes.shape({
		heading: PropTypes.string,
		quoteContainer: PropTypes.string,
		image: PropTypes.string,
		textContent: PropTypes.string,
		source: PropTypes.string,
	}),
	displayTitle: PropTypes.string,
	image: PropTypes.object,
	quote: PropTypes.string,
	source: PropTypes.string,
	date: PropTypes.string,
	branding: PropTypes.string,
};

Testimonial.defaultProps = {
	className: undefined,
	classNames: undefined,
	displayTitle: undefined,
	image: undefined,
	quote: undefined,
	source: undefined,
	date: undefined,
	branding: undefined,
};

export default Testimonial;
export { Testimonial };
